import { render, staticRenderFns } from "./TaxableRebateSetupGrid.vue?vue&type=template&id=4724eccc"
import script from "./TaxableRebateSetupGrid.vue?vue&type=script&lang=js"
export * from "./TaxableRebateSetupGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports